import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faCalendarAlt,
  faCheckCircle,
  faCircle,
  faClock,
  faEye,
  faEyeSlash,
  faFile,
  faFilePdf,
  faListAlt,
  faStar,
  faTrashAlt
} from '@fortawesome/free-regular-svg-icons';
import {
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faBan,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faDownload,
  faEdit,
  faExchangeAlt,
  faFileUpload,
  faFolder,
  faFolderOpen,
  faQuestion,
  faQuestionCircle,
  faStar as star,
  faStarHalfAlt,
  faTimes,
  faUnlock,
  faUser,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppEffects } from './store/app.effects';
import { rootReducer } from './store/app.reducer';
import { PepListEffects } from './store/pep-check/pep-list.effect';
import { TagsEffects } from './store/tags';
import { ApiModule, Configuration } from 'schema';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ApiModule.forRoot(() => new Configuration({ basePath: environment.baseUrl.slice(0,-1) })),
    AppRoutingModule,
    CoreModule,
    StoreModule.forRoot(rootReducer),
    EffectsModule.forRoot([AppEffects, TagsEffects, PepListEffects]),
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 25 }) : []
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private library: FaIconLibrary) {
    library.addIcons(
      faEye,
      faEyeSlash,
      faStar,
      star,
      faStarHalfAlt,
      faFilePdf,
      faTrashAlt,
      faUser,
      faChevronDown,
      faChevronUp,
      faCheck,
      faQuestion,
      faTimes,
      faBan,
      faUnlock,
      faArrowLeft,
      faChevronRight,
      faExchangeAlt,
      faClock,
      faArrowDown,
      faArrowUp,
      faQuestionCircle,
      faFolder,
      faFolderOpen,
      faFile,
      faFileUpload,
      faDownload,
      faEdit,
      faUsers,
      faCalendarAlt,
      faListAlt,
      faCheckCircle,
      faCircle
    );
  }
}
